import { render, staticRenderFns } from "./StudentRoadmapPanel.vue?vue&type=template&id=73c62be6"
import script from "./StudentRoadmapPanel.vue?vue&type=script&lang=js"
export * from "./StudentRoadmapPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports